import { generateSetChild, generateAddArrayChild, generateUpdateArrayChild, generateRemoveArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'
import { format } from '@/utils/format'

export default {
	namespaced: true,
	state: {
		email: null,
		brands: []
	},
	actions: {
		async setEmail({commit}, {email = null}) {
			commit('setEmail', {item: email});
		},
		async getBrands({ commit, dispatch, state}, { email = null, accumulatorGroup = null } = {}) {
			if (email) {
				commit('setEmail', {item: email});
				try {
					let result = await service.migrationBrands({email, accumulatorGroup});
					commit('setBrands', { item: result.brands || [] })
				} catch(err) {
					throw err
				}
			}
		},
		async startMigration({}, {email, checkTerms, accumulatorGroup = null}) {
			const migrateVerifyUrl = format(config.MIGRATION_VERIFY_URL, { email });
			return await service.migrationStart({email, brand: config.BRAND, checkTerms, migrateVerifyUrl, accumulatorGroup})
		},
		async verifyMigration({}, {email, token, accumulatorGroup = null}) {
			return await service.migrationVerify({email, token, brand: config.BRAND, accumulatorGroup})
		}
	},
	getters: {
		migrationEmail(state) {
			return state.email;
		},
		migrationBrands(state) {
			return state.brands.map(brand => {
				if (brand.code == config.BRAND) {
					brand.current = true;
				}
				return brand;
			});
		}
	},
	mutations: {
		setEmail: generateSetChild("email"),
		setBrands: generateSetChild("brands"),
	}
}